import { 
  SETTLEMENTS_ERROR,
  SETTLEMENTS_SUCCESS,
  SETTLEMENTS_LOADING,
  SETTLEMENT_CREATION_SET_SPONSOR_SLUG,
  SETTLEMENT_CREATION_SET_DATE_FROM,
  SETTLEMENT_CREATION_SET_DATE_TO,
  SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE,
  SELECT_SETTLEMENT_FOR_DETAIL,
  SET_SETTLEMENT_DETAIL,
  CLEAN_SETTLEMENT_DETAIL,
  SETTLEMENT_CREATION_BACK_STEP,
  SETTLEMENT_CREATION_NEXT_STEP,
  SET_PENDING_AUTHORIZATIONS,
  SET_SETTLEMENT_ID,
  CLEAR_SETTLEMENT_CREATION,
  SET_CLAIMS,
  CLEAR_CLAIMS,
  SET_EXCLUDED_CLAIMS,
  CLEAR_EXCLUDED_CLAIMS,
  COMPLETE_ADD_AUTHORIZATIONS_STEP,
  SET_SETTLEMENT_CREATION_RESULT
}from '@/store/mutation-types';

export default {

  [SETTLEMENTS_SUCCESS]: (state, payload) => {
      state.settlements = payload.content
      state.links = payload.links
      state.page = payload.page
  },

  [SETTLEMENTS_ERROR]: (state, payload) => {
      state.errorAlert = true
      state.createSettlement.errorMessage = payload
  },

  [SETTLEMENTS_LOADING]: (state, payload) => {
      state.loadingSettlements = payload
  },

  [SETTLEMENT_CREATION_SET_SPONSOR_SLUG]: (state, payload) => {
    state.createSettlement.sponsorSlug = payload
  },

  [SETTLEMENT_CREATION_SET_DATE_FROM]: (state, payload) => {
    state.createSettlement.dates.from = payload
  },

  [SETTLEMENT_CREATION_SET_DATE_TO]: (state, payload) => {
    state.createSettlement.dates.to = payload
  },

  [SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE]: (state, payload) => {
    state.createSettlement.sponsorSelectionComplete = payload
  },
  
  [SELECT_SETTLEMENT_FOR_DETAIL]: (state, payload) => {
    state.settlementSelected = payload
  },

  [SET_SETTLEMENT_DETAIL]: (state, payload) => {
    state.settlementDetail = payload.content
    state.links = payload.links
    state.page = payload.page
  },

  [CLEAN_SETTLEMENT_DETAIL]: (state) => {
    state.settlementDetail = []
    state.links = {}
    state.page = {}
  },

  [SETTLEMENT_CREATION_BACK_STEP]: (state) => {
    if(state.createSettlement.actualStep > 1){
      state.createSettlement.actualStep--;
    }
  },

  [SETTLEMENT_CREATION_NEXT_STEP]: (state) => {
    state.createSettlement.actualStep++;
  },

  [SET_PENDING_AUTHORIZATIONS]: (state, payload) => {
    state.authorizations = payload.content,
    state.links = payload.links
    state.page = payload.page
  },

  [SET_SETTLEMENT_ID]: (state, payload) => {
    state.createSettlement.settlementId = payload
  },

  [CLEAR_SETTLEMENT_CREATION]: (state) => {
    state.createSettlement= {
      sponsorSelectionComplete: false,
      settlementId: {},
      sponsorSlug: {},
      dates: {
        from: "",
        to: ""
      },
      actualStep: 1
    }
  },
  
  [SET_CLAIMS]: (state, payload) => {
    let items = state.createSettlement.includedClaims
    if(payload.value){
      items.push(payload.item);
      items = [...new Set(items.map(JSON.stringify))].map(JSON.parse)
    }else{
      const index = items.findIndex(item => item.id === payload.item.id)
      if (index !== undefined) {
        items.splice(index, 1);
      }
    }
    state.createSettlement.includedClaims= items
  },

  [SET_EXCLUDED_CLAIMS]: (state, payload) => {
    let items = state.createSettlement.excludedClaims
    if(!payload.value){
      items.push(payload.item);
      items = [...new Set(items.map(JSON.stringify))].map(JSON.parse)
    }else{
      const index = items.findIndex(item => item.id === payload.item.id)
      if (index !== undefined) {
        items.splice(index, 1);
      }
    }
    state.createSettlement.excludedClaims= items
  },

  [CLEAR_CLAIMS]: (state) => {
    state.createSettlement.includedClaims = []
  },

  [CLEAR_EXCLUDED_CLAIMS]: (state) => {
    state.createSettlement.excludedClaims = []
  },

  [COMPLETE_ADD_AUTHORIZATIONS_STEP]: (state, payload) => {
    state.createSettlement.addAuthorizationsComplete = payload
  },
  
  [SET_SETTLEMENT_CREATION_RESULT]: (state, payload) => {
    state.createSettlement.createSettlementResult = payload
  }
}